import Vue from 'vue'
import bcloud from './bcloud-pc.vue'
import { Toast, Icon, Radio, RadioGroup, NoticeBar, Checkbox, Popup, Rate, Dialog, Button } from 'vant'
import '@/scss/reset.css'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
import '@/iconfont/iconfont.css'

Vue.config.productionTip = false

Vue.use(Popup)
Vue.use(Rate)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(NoticeBar)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(Button)

window.SEVER_DEFAULT_PATH = process.env.VUE_APP_SEVER_PATH
window.SEVER_PATH = process.env.VUE_APP_COURSE_SEVER_PATH
window.NUWA_SEVER_PATH = process.env.VUE_APP_NUWA_SEVER_PATH
window.WX_APPID = process.env.VUE_APP_WX_APPID
window.ALI_APPID = process.env.VUE_APP_ALI_APPID

new Vue({
    render: (h) => h(bcloud),
}).$mount('#bcloud-pc')
